export default __webpack_public_path__ + "static/media/chart-home-delivery.c4f1064b.svg";